import React, { useState, useEffect } from 'react';
import { ArrowUpRight, ChevronLeft, ChevronRight } from 'lucide-react';
import img1 from '../../../Assets/Images/HomeImg1.webp';
import img2 from '../../../Assets/Images/HomeImg2.webp';
import img3 from '../../../Assets/Images/HomeImg3.webp';
import { useNavigate } from 'react-router-dom';

const slides = [
  {
    title: "Bridging Engineering & Technology to Build Scalable ",
    highlight: "Digital Systems",
    image: img1,
  },
  {
    title: "We focused on building systems around ",
    highlight: "real-world processes.",
    image: img2,
  },
  {
    title: "Build a System That Actually Fits  ",
    highlight: "Your Operations",
    image: img3,
  },
];

const HomeHero1 = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);

    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setIsAnimating(false);
    }, 500);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);

    setTimeout(() => {
      setCurrentSlide(
        (prev) => (prev - 1 + slides.length) % slides.length
      );
      setIsAnimating(false);
    }, 500);
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);


  useEffect(() => {
  const interval = setInterval(() => {
    nextSlide();
  }, 4000); // change time if needed

  return () => clearInterval(interval);
}, [currentSlide]);

  return (
    <section className=' '>
      <div className="relative bg-gradient-to-br from-[#041427] via-slate-800 to-slate-900 overflow-hidden  px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pt-20 lg:pt-36 ">
        {/* Animated background elements - Responsive */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-blue-600/10 rounded-full blur-2xl sm:blur-3xl -top-24 -left-24 sm:-top-32 sm:-left-32 md:-top-40 md:-left-40 lg:-top-48 lg:-left-48 animate-pulse"></div>
          <div className="absolute w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-purple-600/10 rounded-full blur-2xl sm:blur-3xl top-1/4 sm:top-1/3 md:top-1/2 right-0 animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-64 lg:h-64 bg-blue-500/5 rounded-full blur-xl sm:blur-2xl bottom-0 left-1/4 md:left-1/3 animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        {/* Grid pattern overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px] sm:bg-[size:30px_30px] md:bg-[size:40px_40px]"></div>

        <div className="relative mx-auto px-3 sm:px-4 md:px-6 py-6 sm:py-7 md:py-8  flex flex-col">
          {/* Main content */}
          <div className="relative flex-1 grid lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-center">
            {/* Left content */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-8 order-2 lg:order-1">
              {/* Decorative line */}
              <div 
                className={`flex items-center gap-2 sm:gap-3 transition-all duration-1000 delay-200 ${
                  isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
                }`}
              >
                <div className="w-8 sm:w-10 md:w-12 h-px bg-gradient-to-r from-blue-500 to-transparent"></div>
                <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-500 rounded-full animate-pulse"></div>
              </div>

              {/* Heading - Fully responsive text sizes */}
              <div className="space-y-1 sm:space-y-1.5 md:space-y-2">
                <h1
                  className={`text-3xl  sm:text-4xl md:text-5xl font-bold text-white leading-snug sm:leading-tight md:leading-tight  ${
                    isAnimating
                      ? "opacity-0 -translate-y-4 sm:-translate-y-6"
                      : "opacity-100 translate-y-0"
                  }`}
                >
                  {slides[currentSlide].title}
                  <span
                  className={`ml-2 text-3xl sm:text-4xl md:text-5xl font-bold  text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 leading-snug sm:leading-tight md:leading-tight transition-all duration-500 delay-100 ${
                    isAnimating
                      ? "opacity-0 translate-y-4 sm:translate-y-6"
                      : "opacity-100 translate-y-0"
                  }`}
                >
                  {slides[currentSlide].highlight}
                </span>
                </h1>

                
              </div>

              {/* Description */}
              <p 
                className={`text-slate-300 text-sm sm:text-base md:text-lg max-w-full sm:max-w-md md:max-w-xl leading-relaxed transition-all duration-1000 delay-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                We design and build custom digital solutions tailored to the operational workflows of biotech, construction, and manufacturing Industries.
              </p>

              {/* Buttons - Responsive sizing and layout */}
              <div 
                className={`flex flex-row  gap-3 sm:gap-4 transition-all duration-1000 delay-900 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                <button 
                onClick={()=>{
                  navigate("/services");
                  window.scrollTo({
                    top:0,
                    behavior: "smooth"
                  });
                }}
                className="px-4 py-2.5 sm:px-6 sm:py-3 md:px-8 md:py-4 border-2 border-blue-500/50 text-white rounded-lg font-medium hover:bg-blue-500/10 hover:border-blue-400 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-blue-500/20 text-sm sm:text-base">
                  Explore Our Services
                </button>
                {/* <button className="transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-white/20  group">
                  <span className='px-4 py-2.5 sm:px-6 sm:py-3  md:py-4 flex items-center gap-3 bg-white text-slate-900 rounded-lg font-medium text-sm sm:text-base'>
                    Book a Consultation
                       <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </span>
                </button> */}
              </div>
            </div>

            {/* Center floating badge - Responsive positioning */}
            <div className="absolute left-16 -translate-x-1/2 bottom-40 sm:top-12 lg:left-[60%] -translate-y-1/2 z-20 pointer-events-none order-1 lg:order-2">
              <div className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-52 lg:h-52 flex items-center justify-center">
                {/* Outer ring */}
                <div className="absolute inset-0 rounded-full border border-blue-500/40 animate-spin-slow" />

                {/* Orbiting dot */}
                <div className="absolute inset-0 animate-orbit">
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 bg-blue-500 rounded-full" />
                </div>

                {/* Inner white circle */}
                <div className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-44 lg:h-44 rounded-full bg-white flex items-center justify-center">
                  <div className="absolute inset-0 top-0 animate-spin-reverse">
                    <svg viewBox="0 0 200 200" className="w-full h-full">
                      <defs>
                        <path
                          id="circlePath"
                          d="M 100,100 m -70,0 a 70,70 0 1,1 140,0 a 70,70 0 1,1 -140,0"
                        />
                      </defs>
                      <text fill="#0f172a" fontSize="16" letterSpacing="2">
                        <textPath xlinkHref="#circlePath" startOffset="50%" textAnchor="middle">
                          EXPERIENCE • QUANTROVIA • 5+ YEARS •
                        </textPath>
                      </text>
                    </svg>
                  </div>

                  <div className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-indigo-400 rotate-45 rounded-sm" />
                </div>
              </div>
            </div>

            {/* Right content - Image section */}
            <div className="relative order-3 lg:order-3 ml-3 mt-12 sm:mt-12 md:mt-16 lg:mt-0">
              <div 
                className={`relative transition-all duration-1000 delay-500 ${
                  isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
                }`}
              >
                {/* Responsive image container */}
                <div className="flex justify-center relative lg:absolute -top-0 sm:-top-4 md:-top-8 lg:-top-52 xl:-top-56 right-0 w-full lg:w-auto">
                  <img
                    src={slides[currentSlide].image}
                    alt=""
                    className={`w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl h-auto lg:h-[400px] xl:h-[550px] object-contain transition-all duration-500 ${
                      isAnimating
                        ? "opacity-0 scale-95 translate-x-10"
                        : "opacity-100 scale-100 translate-x-0"
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom navigation */}
          <div className="flex items-center justify-between pt-4 sm:pt-6 md:pt-8">
            <div 
              className={`flex gap-2 transition-all duration-1000 delay-1100 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <button 
                onClick={prevSlide}
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-600/20 hover:bg-blue-600/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all hover:scale-110 border border-blue-500/30"
              >
                <ChevronLeft className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              </button>
              <button 
                onClick={nextSlide}
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-600/20 hover:bg-blue-600/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all hover:scale-110 border border-blue-500/30"
              >
                <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              </button>
            </div>
          </div>
        </div>

        <style>{`
          @keyframes gradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          
          .animate-gradient {
            animation: gradient 3s ease infinite;
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          .animate-float {
            animation: float 3s ease-in-out infinite;
          }

          @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .animate-spin-slow {
            animation: spin-slow 20s linear infinite;
          }

          @keyframes spin-reverse {
            from { transform: rotate(0deg); }
            to { transform: rotate(-360deg); }
          }

          .animate-spin-reverse {
            animation: spin-reverse 15s linear infinite;
          }

          @keyframes orbit {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .animate-orbit {
            animation: orbit 10s linear infinite;
          }

          /* Responsive font size for SVG text */
          @media (max-width: 640px) {
            svg text {
              font-size: 14px !important;
              letter-spacing: 1px !important;
            }
          }
          
          @media (min-width: 641px) and (max-width: 768px) {
            svg text {
              font-size: 16px !important;
              letter-spacing: 1.5px !important;
            }
          }
          
          @media (min-width: 769px) {
            svg text {
              font-size: 18px !important;
              letter-spacing: 2px !important;
            }
          }

          /* Custom breakpoint for extra small devices */
          @media (min-width: 375px) {
            .xs\\:text-3xl { font-size: 1.875rem; }
            .xs\\:flex-row { flex-direction: row; }
          }
        `}</style>
      </div>
    </section>
  );
}

export default HomeHero1;